import { Component } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-[hsl(164,28%,14%)] px-4">
          <div className="text-center max-w-md">
            <p className="font-['Inter'] text-xs font-medium uppercase tracking-[0.2em] text-[hsl(var(--silver))] mb-4">
              Something went wrong
            </p>
            <h1 className="font-['Cormorant_Garamond'] text-3xl font-bold text-[hsl(var(--foreground))] mb-6">
              An Unexpected Error
            </h1>
            <p className="font-['Inter'] text-sm leading-[1.7] text-[hsl(var(--muted-foreground))] mb-8">
              The page encountered an error. Please try refreshing, or return to the homepage.
            </p>
            <button
              onClick={() => { this.setState({ hasError: false }); window.location.href = '/'; }}
              className="inline-flex items-center justify-center px-8 py-3 rounded-lg bg-[hsl(var(--primary))] text-[hsl(var(--primary-foreground))] font-['Inter'] text-sm font-medium hover:brightness-[1.03] transition-all"
            >
              Return Home
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
